// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NvidiaContainer_NvidiaContainer_2D9SJ {\n  padding: 30px;\n  border: 1px solid #bfbfbf;\n  margin: auto;\n  background-color: white;\n  margin: 15px 0;\n  border-radius: 5px;\n  -webkit-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.12),\n    0 1px 3px 0 rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.12),\n    0 1px 3px 0 rgba(0, 0, 0, 0.2);\n}\n", ""]);
// Exports
exports.locals = {
	"NvidiaContainer": "NvidiaContainer_NvidiaContainer_2D9SJ"
};
module.exports = exports;
